//START GENAI@GHCOPILOT
import { pushINOData, setUserTypeId } from 'common/gamp';
import { markEnd, markStart, getEmvcoLoadTiming } from 'common/instrumentation';
//START GENAI@GHCOPILOT
import { ONBOARDED_NETWORKS } from 'common/network-partners';
//END GENAI@GHCOPILOT
import {
  CommunicatorState,
  getState,
  saveApiResponseCache,
  saveMeta,
  saveSupportedCardNetworks
} from 'orch-communicator/store';
import {
  getMerchantProperties,
  getQueryAttributes,
  getSupportedCardNetworks
} from 'orch-communicator/store/selectors';
import { dynamicDataTypeMapping } from 'orch-communicator/utils/dynamic-data-type';
import { getCardBrandApiKey } from 'orch-communicator/utils/get-api-key-for-card-brand';
import { removeUndefinedProperties } from 'orch-communicator/utils/get-dpa-transaction-options';
import { waitForSDKs } from 'orch-communicator/utils/wait-for-sdks';
import { MerchantConfig, SRCInfo } from 'types/data';
import { InitDataVSB } from 'types/vsb-sdk/init';
import createCorrelationId from '../utils/correlation-id';
// END GENAI@GHCOPILOT
export async function init(validatedInitData: InitDataVSB) {
  markStart('vsb_init');

  await waitForSDKs();

  //eslint-disable-next-line
  const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
  //eslint-disable-next-line
  try {
    //START GENAI@GHCOPILOT
    // eslint-disable-next-line
    // @ts-ignore

    const merchantProfileResponse: {
      merchantConfig: MerchantConfig;
      srcInfo: SRCInfo;
    } = getMerchantProperties();

    //START GENAI@GHCOPILOT
    if (
      validatedInitData.dpaTransactionOptions &&
      !validatedInitData.dpaTransactionOptions.merchantName
    ) {
      //eslint-disable-next-line
      validatedInitData.dpaTransactionOptions.merchantName =
        merchantProfileResponse.merchantConfig.logo?.displayName || '';
    }
    //END GENAI@GHCOPILOT

    //START GENAI@GHCOPILOT

    let clientId = '';

    if (getQueryAttributes()?.dpaClientId) {
      //eslint-disable-next-line
      clientId = getQueryAttributes()?.dpaClientId || '';
    }

    const requestedCardNetworks = getSupportedCardNetworks();
    //START GENAI@GHCOPILOT
    let supportedCardNetworks = requestedCardNetworks.filter(cardBrand =>
      ONBOARDED_NETWORKS.includes(cardBrand.toUpperCase())
    );
    //END GENAI@GHCOPILOT
    /*eslint-disable-next-line*/
    console.log(
      `Requested CardNetworks >> ${requestedCardNetworks}  supported CardNetworks => ${supportedCardNetworks}`
    );

    const dpaIdFromQuery = getQueryAttributes()?.dpaId || '';

    //END GENAI@GHCOPILOT

    const isRecognizedResponses: { [key: string]: boolean } = {};
    const initResponses: { [key: string]: boolean } = {}; // Initialize the initResponses object
    const tokens: { [key: string]: string[] } = {};
    const initDatas: { [key: string]: object } = {};

    if (supportedCardNetworks.length === 0) {
      supportedCardNetworks = ['VISA'];
    }

    saveSupportedCardNetworks(supportedCardNetworks);

    //START GENAI@GHCOPILOT

    //START GENAI@GHCOPILOT
    //START GENAI@GHCOPILOT
    //eslint-disable-next-line
    const promises = (supportedCardNetworks ?? []).map(async cardBrand => {
      //START GENAI@CHATGPT4

      let dynamicDataType: string | undefined = undefined;
      //eslint-disable-next-line
      let paymentOptions: any = validatedInitData.dpaTransactionOptions?.paymentOptions;

      if (validatedInitData.dpaTransactionOptions && paymentOptions && paymentOptions.length > 0) {
        dynamicDataType =
          dynamicDataTypeMapping[cardBrand][paymentOptions[0].dynamicDataType as string];
      }

      if (cardBrand === 'VISA' && dynamicDataType && paymentOptions) {
        //eslint-disable-next-line
        paymentOptions = paymentOptions.map((option: any) => ({
          ...option,
          dynamicDataType: dynamicDataType ? dynamicDataType : option.dynamicDataType
        }));
      } else if (cardBrand === 'MASTERCARD' && dynamicDataType && paymentOptions) {
        paymentOptions = dynamicDataType
          ? {
              ...paymentOptions[0],
              //eslint-disable-next-line
              dynamicDataType: dynamicDataType
            }
          : paymentOptions[0];
      }

      const apiKey =
        cardBrand !== 'VISA' ? getCardBrandApiKey(merchantProfileResponse.srcInfo, cardBrand) : '';

      /**
       * START GENAI@GHCOPILOT
       * The below code snippet is used to initialize the SDK.
       * It initializes the SDK with the init data passed by the merchant.
       * @param vsbInitData - The data passed by the merchant to initialize the SDK.
       * @returns void
       * END GENAI@GHCOPILOT
       */
      //START GENAI@GHCOPILOT
      //START GENAI@GHCOPILOT
      const vsbInitData: {
        //eslint-disable-next-line
        dpaTransactionOptions: any;
        srciDpaId: string;
        srcInitiatorId: string | null;
        srciTransactionId: string;
        dpaData?: { dpaName?: string; dpaPresentationName?: string };
      } = {
        dpaTransactionOptions: {
          ...validatedInitData.dpaTransactionOptions,
          //START GENAI@GHCOPILOT
          consumerEmailAddressRequested: true,
          consumerNameRequested: true,
          consumerPhoneNumberRequested: true,
          //END GENAI@GHCOPILOT
          dpaBillingPreference:
            validatedInitData.dpaTransactionOptions?.dpaBillingPreference?.trim() ||
            merchantProfileResponse.merchantConfig.billingConstraints?.collectBillingAddress?.trim(),
          dpaLocale: validatedInitData.dpaTransactionOptions?.dpaLocale?.trim() || 'en_US',
          //START GENAI@GHCOPILOT
          dpaShippingPreference:
            validatedInitData.dpaTransactionOptions?.dpaShippingPreference?.trim() ||
            (merchantProfileResponse.merchantConfig.shippingConstraints?.collectShipping
              ? 'FULL'
              : 'NONE'),
          //END GENAI@GHCOPILOT
          //eslint-disable-next-line
          paymentOptions: paymentOptions
        },
        srciDpaId:
          cardBrand !== 'VISA'
            ? //eslint-disable-next-line
              merchantProfileResponse?.merchantConfig?.clientId?.trim() || ''
            : clientId,
        srcInitiatorId: cardBrand !== 'VISA' ? apiKey : dpaIdFromQuery,
        srciTransactionId: getState().meta.correlationId
      };

      //START GENAI@GHCOPILOT
      /* updating merchant name from merchantProfileResponse
      if no merchant name is available in validatedInitData */
      /*eslint-disable-next-line */
      if (!vsbInitData?.dpaTransactionOptions?.merchantName) {
        vsbInitData.dpaTransactionOptions.merchantName =
          merchantProfileResponse.merchantConfig.logo?.displayName;
      }
      //END GENAI@GHCOPILOT

      //START GENAI@GHCOPILOT
      if (cardBrand === 'VISA') {
        vsbInitData.dpaTransactionOptions.customInputData = {
          ...vsbInitData.dpaTransactionOptions.customInputData,
          checkoutOrchestrator: 'merchant',
          isVsbButtonless: true
        };
      }

      //START GENAI@GHCOPILOT
      if (vsbInitData.dpaTransactionOptions && cardBrand === 'VISA') {
        if (!vsbInitData.dpaData) {
          vsbInitData.dpaData = {};
        }

        vsbInitData.dpaData.dpaPresentationName = vsbInitData.dpaTransactionOptions.merchantName;
      }
      //END GENAI@GHCOPILOT

      if (vsbInitData.dpaTransactionOptions && cardBrand === 'MASTERCARD') {
        if (!vsbInitData.dpaData) {
          vsbInitData.dpaData = {};
        }

        vsbInitData.dpaData.dpaName = vsbInitData.dpaTransactionOptions.merchantName;
      }
      //END GENAI@GHCOPILOT

      removeUndefinedProperties(vsbInitData.dpaTransactionOptions);
      //END GENAI@GHCOPILOT

      initDatas[cardBrand] = vsbInitData;
      //END GENAI@GHCOPILOT
      //END GENAI@CHATGPT4
      //END GENAI@GHCOPILOT

      try {
        //eslint-disable-next-line
        console.log(`---------------- init() for ${cardBrand}`, vsbInitData);
        //* START GENAI@GHCOPILOT */
        markStart(`vsb_init_${cardBrand}`);
        await vSDK[cardBrand].init(vsbInitData);
        markEnd(`vsb_init_${cardBrand}`);
        /* END GENAI@GHCOPILOT */
        initResponses[cardBrand] = true;
      } catch (e) {
        //eslint-disable-next-line
        console.log(`Init call failed for ${cardBrand}:`, e);
        initResponses[cardBrand] = false;
        throw e;
      }

      if (initResponses[cardBrand]) {
        try {
          /* START GENAI@GHCOPILOT */
          markStart(`vsb_isRecognized_${cardBrand}`);
          const isRecognizedRes = await vSDK[cardBrand].isRecognized();
          const recognized = isRecognizedRes?.recognized;
          const idToken = isRecognizedRes?.idTokens;
          isRecognizedResponses[cardBrand] = recognized;
          //eslint-disable-next-line

          //START GENAI@GHCOPILOT
          /* eslint-disable */
          if (!tokens['idTokens'] || tokens['idTokens'].length === 0) {
            tokens['idTokens'] = recognized === true ? idToken : [];
          }
          /* eslint-enable */
          //END GENAI@GHCOPILOT

          markEnd(`vsb_isRecognized_${cardBrand}`);
          /* END GENAI@GHCOPILOT */
        } catch (e) {
          //eslint-disable-next-line
          console.log(`isRecognized call failed for ${cardBrand}:`, e);
          isRecognizedResponses[cardBrand] = false;
          throw e;
        }
      }
    });

    //END GENAI@GHCOPILOT
    await Promise.all(promises)
      .then(() => {
        /*eslint-disable-next-line*/
        console.log('All sdks are loaded successfully');
      })
      .catch(error => {
        /*eslint-disable-next-line*/
        console.log('sdks are not loaded successfully', error);
      })
      .finally(() => {
        //eslint-disable-next-line
        const communicatorState = getState() as CommunicatorState;
        const apiResponseCache = {
          ...communicatorState.srcSdks.apiResponseCache,
          idTokens: tokens,
          init: initResponses,
          initData: initDatas,
          isRecognized: isRecognizedResponses
        };

        saveApiResponseCache(apiResponseCache);
        /*eslint-disable-next-line*/
        console.log('apiResponseCache', apiResponseCache);
        markEnd('vsb_init');

        pushINOData(null, 'VSB Init INO PERF', 'vsb_init_');
        pushINOData(null, 'VSB Init INO Recognized', 'vsb_isRecognized_');
      });

    setUserTypeId(isRecognizedResponses);
  } catch (e) {
    /*eslint-disable-next-line*/
    console.log(e);
  }
  //END GENAI@GHCOPILOT
}

/**
 * START GENAI@GHCOPILOT
 * The below function is the entry point for the initialize API.
 * It is called when the merchant calls the initialize API.
 * It saves the init data in the store and initializes the SDK.
 * @param InitData - The data passed by the merchant to initialize the SDK.
 * @returns void
 * END GENAI@GHCOPILOT
 */
export default async function initialize(validatedInitData: InitDataVSB) {
  // saveInitData(validatedInitData);

  const metaUpdates: Partial<CommunicatorState['meta']> = {
    //eslint-disable-next-line
    correlationId:
      // validatedInitData.customData?.correlationId ||
      createCorrelationId()
  };

  saveMeta(metaUpdates);
  await init(validatedInitData);
  getEmvcoLoadTiming();
}
